
import PedidoEnviadoDialog from '@/components/dialogs/checkout/PedidoEnviadoDialog.vue'
import QuestionDialog from '@/components/dialogs/QuestionDialog.vue'
import PedidoTotais from '@/components/pedido/PedidoTotais.vue'
import DateInput from '@/components/wmc/DateInput.vue'
import CupomDesconto from '@/components/checkout/CupomDesconto.vue'
import PedidoService from '@/services/PedidoService'
import Vue from 'vue'
import Component from 'vue-class-component'
import { Watch } from 'vue-property-decorator'
import { namespace } from 'vuex-class'
import CreditoInterface from '../../interfaces/Credito'
import Financeiro from '../../interfaces/Financeiro'
import Logistica from '../../interfaces/Logistica'
import ClienteService from '../../services/ClienteService'
import { moneyFormatter } from '../utils'

const PedidoStore = namespace('Pedido')
const AppConfigStore = namespace('AppConfig')

type LimiteCredito = {
  creditos: CreditoInterface[]
  controlar_limite_credito: boolean
  limite_excedido_acao: number // 1 - bloquear, 2 - aprovar
}

@Component({
  name: 'CheckoutCondicoesContainer',
  components: {
    DateInput,
    QuestionDialog,
    PedidoEnviadoDialog,
    PedidoTotais,
    CupomDesconto
  }
})
export default class CheckoutCondicoesContainer extends Vue {
  @PedidoStore.Getter
  private getPedido!: any

  @PedidoStore.Getter
  private getErrorMessage!: any[]

  @AppConfigStore.Getter
  private getConfigLogistica!: Logistica

  @AppConfigStore.Getter
  private getConfigFinanceiro!: Financeiro

  @PedidoStore.Action
  private enviarAtualizacaoPedido!: (args?: {
    force?: boolean
    finalizar?: boolean
  }) => Promise<any>

  @PedidoStore.Action
  private atualizarCondicoesPedido!: (payload: {
    comprador?: string
    ordemCompra?: string
    condicaoPgto?: any
    portador?: any
    observacoes?: string
    dataEntrega?: string
  }) => Promise<any>

  @PedidoStore.Action
  private aplicarCupomDesconto!: (cupomDesconto: any[]) => Promise<any>

  private listaPortadores = [] as Array<any>
  listaCondicoesCompleta = [] as Array<any>
  private listaCondicoes = [] as Array<any>
  private enviandoPedido = false
  private envioValido = false
  private limiteCredito = {} as LimiteCredito
  private allowedWeekDays = [] as number[]
  private alert = true

  private envioVazioRules = [
    (v: any) => {
      return (!!v && Object.keys(v).length > 0) || 'Campo obrigatório'
    }
  ]

  get getEndereco() {
    const endereco = this.getPedido.user?.cliente?.endereco

    return [
      `${endereco?.logradouro}, ${endereco?.numero} - ${endereco?.bairro}`,
      `${endereco?.cidade} - ${endereco?.estado} - CEP: ${endereco?.cep}`
    ]
  }

  get portador() {
    return this.getPedido.portador
  }

  get condicaoPgto() {
    return this.getPedido.condicaoPgto
  }

  get observacoes() {
    return this.getPedido.observacoes
  }

  get comprador() {
    return this.getPedido.comprador
  }

  get ordemCompra() {
    return this.getPedido.ordemCompra
  }

  get dataEntrega() {
    return this.getPedido.dataEntrega
  }

  get cupomErrors() {
    this.alert = true
    return (
      this.getErrorMessage?.filter(error => error.type == 'CUPOM_DESCONTO') ||
      []
    )
  }

  async mounted() {
    await this.buscarPortadores()
    await this.buscarCondicoesPgto()

    // se o portador possue uma condicao de pagamento
    const portador = this.listaPortadores.find(el => el.id == this.portador?.id)
    if (portador?.condicao) {
      this.listaCondicoes = [portador.condicao]
    }

    // caso nao possua condicao setada e exista apenas uma
    if (!this.condicaoPgto && this.listaCondicoes.length === 1) {
      this.atualizarCondicoesPedido({
        condicaoPgto: this.listaCondicoes[0]
      })
    }

    this.selecionarAvista()
  }

  porcentagemLimiteCreditoUtilizado(credito: CreditoInterface) {
    if (credito?.limite_credito_disponivel < 0) return 0
    return (
      ((credito?.limite_credito_disponivel || 0) /
        (credito?.limite_credito || 0)) *
      100
    )
  }

  moneyFormatter(valor: number) {
    return valor < 0 ? 'R$ 0,00' : moneyFormatter(valor)
  }

  async buscarPortadores() {
    await PedidoService.findPortadores().then(resp => {
      this.listaPortadores = resp.data
    })
  }

  async buscarCondicoesPgto() {
    await PedidoService.findCondicoesPgto().then(resp => {
      this.listaCondicoes = resp.data
    })

    this.listaCondicoesCompleta = this.listaCondicoes || []
  }

  getRotaEntrega() {
    ClienteService.getRotaEntrega().then(resp => {
      const rota = resp?.data?.[0] as any
      const days: number[] = []

      if (rota?.dias_entrega_segunda) days.push(1)
      if (rota?.dias_entrega_terca) days.push(2)
      if (rota?.dias_entrega_quarta) days.push(3)
      if (rota?.dias_entrega_quinta) days.push(4)
      if (rota?.dias_entrega_sexta) days.push(5)
      if (rota?.dias_entrega_sabado) days.push(6)
      if (rota?.dias_entrega_domingo) days.push(0)

      this.allowedWeekDays = days
    })
  }

  @Watch('getPedido', { immediate: true, deep: true })
  onPedidoChanged() {
    if (!this.getPedido?.user?.cliente?.id && !this.enviandoPedido) {
      this.$router.push('/home')
    }

    this.selecionarAvista()
  }

  selecionarAvista() {
    // if dinheiro ou pix, condicao somente a vista
    if (
      this.getPedido?.portador?.descricao?.toLowerCase().includes('dinheiro') ||
      this.getPedido?.portador?.descricao?.toLowerCase().includes('pix')
    ) {
      const avista = this.listaCondicoesCompleta?.filter(el =>
        el.descricao.toLowerCase().includes('vista')
      )

      if (avista.length) this.listaCondicoes = avista

      return
    }
  }

  @Watch('getConfigFinanceiro', { immediate: true, deep: true })
  async onConfigFinanceiroChanged(newVal: any) {
    if (newVal) {
      if (this.getConfigFinanceiro?.controlar_limite_credito) {
        await this.getLimiteCredito()
      }
    }
  }

  @Watch('getConfigLogistica', { immediate: true, deep: true })
  async onConfigLogisticaChanged(newVal: any) {
    if (newVal) {
      if (this.getConfigLogistica?.informar_data_entrega) {
        await this.getRotaEntrega()
      }
    }
  }

  getLimiteCredito() {
    ClienteService.getCredito().then(resp => {
      this.limiteCredito = resp?.data as LimiteCredito
    })
  }
  onEnviarPedidoClick() {
    const form = this.$refs.form as any
    form.validate()

    if (!this.envioValido) {
      return
    }

    const dlg = this.$refs.dlgQuestionEnvPed as QuestionDialog
    dlg.show(null, {
      title: 'Enviar Pedido',
      message: 'Deseja realmente enviar o pedido?',
      aprovarLabel: 'Sim',
      cancelarLabel: 'Não'
    })
  }

  handleEnvioPedido() {
    this.enviandoPedido = true
    this.enviarAtualizacaoPedido({ finalizar: true })
      .then(() => {
        const dlg = this.$refs.dlgPedFim as PedidoEnviadoDialog
        dlg.show()
      })
      .finally(() => {
        this.enviandoPedido = false
      })
  }

  updateComprador(event: any) {
    this.atualizarCondicoesPedido({
      comprador: event.target.value
    })
  }

  updateObservacoes(event: any) {
    this.atualizarCondicoesPedido({
      observacoes: event.target.value
    })
  }

  updatePortador(event: any) {
    const obj = this.listaPortadores.find(el => el.id === event)
    this.atualizarCondicoesPedido({
      portador: obj
    })

    // caso o portador possua uma condição de pagamento, atualiza a condição de pagamento
    if (obj?.condicao) {
      this.listaCondicoes = [obj.condicao]
      this.atualizarCondicoesPedido({
        condicaoPgto: obj.condicao
      })
    }

    // caso o portador não possua condição de pagamento, atualiza a lista de condições
    if (!obj?.condicao) {
      this.listaCondicoes = this.listaCondicoesCompleta
    }

    // caso exista apenas uma condição de pagamento
    if (this.listaCondicoes.length === 1) {
      this.atualizarCondicoesPedido({
        condicaoPgto: this.listaCondicoes[0]
      })
    }
  }

  updateCondicaoPgto(event: any) {
    const obj = this.listaCondicoes.find(el => el.id === event)
    this.atualizarCondicoesPedido({
      condicaoPgto: obj
    })
  }

  updateOrdemCompra(event: any) {
    this.atualizarCondicoesPedido({
      ordemCompra: event.target.value
    })
  }

  updateDataEntrega(event: string) {
    this.atualizarCondicoesPedido({
      dataEntrega: event
    })
  }

  removerCupom(id: number) {
    const cupons = this.getPedido.cupomDesconto.filter(el => el.id !== id)
    this.aplicarCupomDesconto(cupons)
  }
}
